<main data-cy="profiles-layout__main">
	<ahp-side-navigation
		*ngIf="mobileNavEnabled"
		[@sideNavSlide]="sideNavShow"
		class="mobile_side_nav"
		[isMobileOpen]="mobileNavEnabled"
		(closeMobile)="toggleMobileNav()"
		[attr.aria-hidden]="sideNavShow == 'show' ? 'false' : 'true'"
	>
	</ahp-side-navigation>
	<div *ngIf="mobileNavEnabled" class="side_nav_veil" (click)="toggleMobileNav()"></div>

	<gap-navigation id="mobileTopNav" [ngClass]="{ '--openMobileNav': mobileNavEnabled }" gap-color="primary">
		<gap-navigation-icon slot="menu" aria-label="Main menu" (click)="toggleMobileNav()">
			<gap-iconography gap-icon="menu-outline"></gap-iconography>
		</gap-navigation-icon>
		<div slot="home" class="gap-nav-application-name"> {{ 'nav.appname' | locale }} </div>
	</gap-navigation>

	<div class="nav-content">
		<div class="side-navigation-spacer"></div>
		<ahp-side-navigation id="side-navigation" [isMainNav]="true"></ahp-side-navigation>
		<div class="container">
			<div class="hide-element" role="heading" aria-level="2">{{pageHeading}}</div>
			<router-outlet></router-outlet>
		</div>
	</div>
</main>
